import axios from '@src/libs/axios'

const enabled =
    location.hostname === 'localhost' || location.protocol === 'https:'

function urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/')

    const rawData = window.atob(base64)
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)))
}

export const requestNotificationPermission = async () => {
    if (!enabled) return null
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        return null
    }

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') return null

    const vapidPublicKey = window.env.VAPID_PUBLIC_KEY
    if (!vapidPublicKey) return null

    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
    })

    await axios.post('/api/core/info/push-subscription', subscription.toJSON())

    return subscription
}
